import config from "../../../../config";
import moment from "moment"

export const mapTransactions = (transactions) => {
    const mappedTransactions = [...transactions];
    const returnObject = {
        pendingTransactions: [],
    }
    const transactionsGrouped = {};
    mappedTransactions.forEach(transaction => {
        const year = new Date(transaction.date).getFullYear();
        if (transaction.amount > 0 || transaction.type === 'credit') {
            transaction.status = 'positive';
        } else if (transaction.amount < 0) {
            transaction.status = 'negative';
        }
        if (transaction.pending) {
            returnObject.pendingTransactions.push(transaction)
        } else {
            if (transactionsGrouped[year]) {
                if (transactionsGrouped[year][transaction.formatted_date]) {
                    transactionsGrouped[year][transaction.formatted_date].push(transaction);
                } else {
                    transactionsGrouped[year][transaction.formatted_date] = [transaction];
                }
            } else {
                transactionsGrouped[year] = {};
                transactionsGrouped[year][transaction.formatted_date] = [transaction];
            }
        }
    })
    returnObject.completedTransactions = transactionsGrouped;
    return returnObject
}

export const getHistoryOrderURL = (transaction) => {
    if (transaction.zendesk_ticket_id) {
        return `${config.host_rebag}/my-account/submissions/order-details/${transaction.zendesk_ticket_id}`;
    } else if (transaction.order) {
        return `${config.host_rebag}/my-account/purchases?purchase_id=${transaction.order.replace("#","")}`;
    }
    return null;
}

export const getPartialCashoutModalErrors = (amountValue, cashAmount) => {
    if (!amountValue && amountValue !== 0) return null;
    let errorMessage = "";
    if (amountValue < 10) {
        errorMessage = "You may not cash out an amount less than $10";
    } else if (amountValue > 50000) {
        errorMessage = "Transfer amount is limited to $50,000 per transaction";
    } else if (amountValue > cashAmount) {
        errorMessage = "The value you enter cannot exceed the funds in your account";
    }
    return errorMessage;
}

export const getSelectedMembershipPlan = (amount, membershipPeriod) => {
    let membershipPeriodKey = membershipPeriod;

    if (!membershipPeriod) {
        if (amount > 500) {
            membershipPeriodKey = 'yearly';
        } else {
            membershipPeriodKey = 'monthly';
        }
    }
    return config.subscriptions[membershipPeriodKey].find(sub => sub.amount === amount) || null;
}

export const isDateLessThan24Hours = (date) => {
    const now = moment(); // gets current date and time
    const pastDate = moment(date); // convert the specific date to a moment object
    const duration = moment.duration(now.diff(pastDate));
    const hours = duration.asHours(); // gets the difference in hours

    return hours < 24; // returns true if the difference is less than 24 hours
};

export const calculateAmountRequested = (amountRequested, cashData) => {
    let standardAmount = 0;
    let expeditedAmount = 0;
    let totalAmountAfterFee = 0;

    if (cashData.value >= amountRequested) {
        standardAmount = amountRequested;
        totalAmountAfterFee = standardAmount;
    } else {
        standardAmount = cashData.value;
        expeditedAmount = amountRequested - standardAmount;
        totalAmountAfterFee = amountRequested - (expeditedAmount * cashData.cashout_fee_percent_expedited/100);
    }
    return {
        standardAmount,
        expeditedAmount,
        totalAmountAfterFee,
    }
}
